import { c as _c } from "react/compiler-runtime";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import { CREATE_WAVE_MAIN_STEPS, CREATE_WAVE_STEPS_LABELS } from "@/helpers/waves/waves.constants";
import type { CreateWaveStep } from "@/types/waves.types";
import CreateWavesMainStep from "./CreateWavesMainStep";
export default function CreateWavesMainSteps(t0) {
  const $ = _c(15);
  const {
    waveType,
    activeStep,
    onStep
  } = t0;
  const steps = CREATE_WAVE_MAIN_STEPS[waveType];
  let t1;
  if ($[0] !== activeStep || $[1] !== steps) {
    t1 = steps.indexOf(activeStep);
    $[0] = activeStep;
    $[1] = steps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const activeStepIndex = t1;
  let t2;
  if ($[3] !== activeStepIndex || $[4] !== onStep || $[5] !== steps || $[6] !== waveType) {
    let t3;
    if ($[8] !== activeStepIndex || $[9] !== onStep || $[10] !== steps.length || $[11] !== waveType) {
      t3 = (step, stepIndex) => <CreateWavesMainStep key={step} isLast={stepIndex === steps.length - 1} label={CREATE_WAVE_STEPS_LABELS[waveType][step]} stepIndex={stepIndex} activeStepIndex={activeStepIndex} step={step} onStep={onStep} />;
      $[8] = activeStepIndex;
      $[9] = onStep;
      $[10] = steps.length;
      $[11] = waveType;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = steps.map(t3);
    $[3] = activeStepIndex;
    $[4] = onStep;
    $[5] = steps;
    $[6] = waveType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = <div className="tw-hidden lg:tw-block tw-min-h-full"><nav aria-label="Progress"><div className="tw-flex tw-flex-col tw-items-end">{t2}</div></nav></div>;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}